import React, { useCallback, useState } from 'react';

import api from '../api';
import { Provider as name } from '../config';
import { useGet, useGetById, useGetSchema, usePost, usePut, useRemove, useSoftDelete } from '../../apiHooks';
import { EmailTemplate } from '../types';

import Context from './context';

interface Props {
    children: React.ReactNode;
}

const EmailTemplatesProvider: React.FC<Props> = (props: Props) => {
    const { children } = props;
    const [data, setData] = useState<Array<EmailTemplate>>([]);
    const [schema, setSchema] = useState({});
    const [selected, setSelected] = useState<EmailTemplate | {}>({});
    const [error, setError] = useState({});

    const getById = useGetById(api, selected, setSelected, setError);

    const handleGetData = useCallback((res: EmailTemplate[]) => {
        setData(res);
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    const getSchema = useGetSchema(api, schema, setSchema, setError);

    const handleSetData = useCallback((item: EmailTemplate, newData: EmailTemplate[]) => {
        setData(newData);
    }, []);
    const post = usePost(api, data, handleSetData, setError);

    const put = usePut(api, data, handleSetData, setError);

    const handleDeleteCallback = useCallback((id: string, newData: EmailTemplate[]) => {
        setData(newData);
        setSelected({});
        return id;
    }, []);
    const remove = useRemove(api, data, handleDeleteCallback, setError);

    const softDelete = useSoftDelete(api, data, handleDeleteCallback, setError);

    return (
        <Context.Provider
            value={{
                name,
                get,
                getById,
                getSchema,
                schema,
                post,
                put,
                data,
                setData,
                selected,
                setSelected,
                remove,
                error,
                softDelete
            }}
        >
            {children}
        </Context.Provider>
    );
};

export default EmailTemplatesProvider;
